
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');



window.Vue = require('vue');

import PortalVue from 'portal-vue'
Vue.use(PortalVue);

// media query
import VueMq from 'vue-mq';
Vue.use(VueMq, {
	breakpoints: {
		mobile: 992,
		desktop: Infinity
	}
});


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('mega-menu', require('./components/MegaMenu.vue'));
Vue.component('search-product', require('./components/searchProduct.vue'));
Vue.component('youtube-link', require('./components/YoutubeLink.vue'));
Vue.component('youtube-slide', require('./components/YoutubeSlide.vue'));
Vue.component('q-and-as', require('./components/QAndAs.vue'));
Vue.component('product-page', require('./components/ProductPage.vue'));
Vue.component('flickity', require('vue-flickity'));

const app = new Vue({
	el: '#app',

	data() {
		return {
			_lng: '',
			menuIsOpened: false,
			openedItems: [],
			menuTimeout: null,
		}
	},

	created() {
		// initiating lng prefix
		this._lng = $('#app').data('lng');
	},

	mounted() {

		// preventing vertical scroll
		// over galleries / sliders
		// in iPhone
		this.$nextTick(function () {
			var tapArea, startX ;
			tapArea = document.querySelectorAll('.product-images, .products-slider');
			startX = 0;
			for (var item of tapArea) {
				item.ontouchstart = function(e) {
					startX = e.touches[0].clientX;
				};
				item.ontouchmove = function(e) {
					if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
						e.preventDefault();
					}
				};
			}
		})

		const cookieConsentLink = document.querySelector('#cookies-consent-link');
		if (cookieConsentLink) {
			cookieConsentLink.addEventListener('click', this.consentToCookies)
		}
	},

	beforeDestroy() {
		const cookieConsentLink =document.querySelector('#cookies-consent-link');
		if (cookieConsentLink) {
			cookieConsentLink.removeEventListener('click', this.consentToCookies)
		}
	},

	methods: {
		pauseCarousel(selector) {
			const $carousel = $(selector);
			// pause first: this creates the carousel instance (if needed) and clears the interval
			$carousel.carousel('pause');
			// then kill the interval config so nothing (hover-leave, touch-end) can auto-cycle it again
			const instance = $carousel.data('bs.carousel');
			if (instance) {
				instance._config.interval = false;
			}
		},

		openMenu(itemId) {
			this.openedItems.push(itemId);
			this.clearTimeout();
			this.menuTimeout = setTimeout(() => {
				this.menuIsOpened = true;
				this.clearTimeout();
			}, 250)
		},

		closeMenu(itemId) {
			const index = this.openedItems.indexOf(itemId);
			if (index !== -1) {
				const cloned = [...this.openedItems];
				cloned.splice(index, 1);
				this.openedItems = [...cloned];
			}
			this.clearTimeout();
			this.menuTimeout = setTimeout(() => {
				if (this.openedItems.length <= 0) {
					this.menuIsOpened = false;
				}
			}, 90);
		},

		clearTimeout() {
			if (this.menuTimeout) {
				clearTimeout(this.menuTimeout);
				this.menuTimeout = null;
			}
		},

		consentToCookies(ev) {
			ev.preventDefault();
			fetch(ev.target.getAttribute('href')).then((response) => {
				ev.target.removeEventListener('click', this.consentToCookies);
				const cookiesConsent = document.querySelector('.cookies-consent');
				if (cookiesConsent) {
					cookiesConsent.remove();
				}

			})

		}
	}

});



// WEBPACK FOOTER //
// ./resources/assets/js/site.js